import { music } from './MusicSystem';

export type RadioKind =
  | 'wave'
  | 'waveClear'
  | 'elite'
  | 'boss'
  | 'breach'
  | 'ability'
  | 'victory'
  | 'defeat'
  | 'build'
  | 'upgrade'
  | 'special'
  | 'info';

const LINES: Record<RadioKind, string[]> = {
  wave: [
    'Hostiles inbound. Weapons free.',
    'Contact front. All towers hot.',
    'Mesh signatures on the lane. Engage.',
    'Wave incoming. Hold the line.',
  ],
  waveClear: [
    'Lane clear. Regroup and spend supply.',
    'All hostiles down. Next push will be harder.',
    'Sector quiet — for now.',
  ],
  elite: [
    'Elite signature. Prioritise that contact.',
    'Heavy elite on approach. Focus fire.',
  ],
  boss: [
    'COLOSSUS-CLASS. Cycle abilities. Do not hold back.',
    'Massive hostiles detected. Full response.',
  ],
  breach: [
    'Breach! Command integrity dropping.',
    'They punched through. Shore up the line.',
  ],
  ability: ['Orbital spear authorised.', 'Support asset released.', 'Tactical systems engaged.'],
  victory: ['Installation held. Outstanding work, commander.', 'Kappa secure. All units stand down.'],
  defeat: ['Command overrun. We are losing the site.', 'Fallback! Bastion is failing.'],
  build: ['Hardpoint confirmed.', 'Tower online.', 'Fire support ready.'],
  upgrade: ['Upgrade complete. Systems green.', 'Hardpoint upgraded.'],
  special: ['Special weapon free!', 'Overdrive active!'],
  info: ['Copy that.', 'Standing by.'],
};

let lastPick: Partial<Record<RadioKind, number>> = {};

export class Announcer {
  private queue: string[] = [];

  say(kind: RadioKind, custom?: string): void {
    let msg = custom;
    if (!msg) {
      const pool = LINES[kind] ?? LINES.info;
      let idx = Math.floor(Math.random() * pool.length);
      if (lastPick[kind] === idx) idx = (idx + 1) % pool.length;
      lastPick[kind] = idx;
      msg = pool[idx];
    }
    this.queue.push(msg);
    if (kind === 'wave') music.stinger('wave');
    if (kind === 'boss') music.stinger('boss');
    if (kind === 'breach') music.stinger('breach');
    if (kind === 'ability' || kind === 'special') music.stinger('ability');
  }

  /** Next queued message or null. */
  dequeue(): string | null {
    return this.queue.shift() ?? null;
  }
}

export const announcer = new Announcer();
